// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-item[data-v-5109685d]:first-child {\n  margin-left: 2.5rem;\n}", ""]);
// Exports
module.exports = exports;
